module.exports = __webpack_public_path__ + "static/media/congratulations.902aa023.png";